/**
 * @fileoverview PATCH handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions/:action_id" endpoint.
 * Updates one action bank row. Conman merges only the fields sent, so a partial
 * list is safe. The route always updates in place, so replacement_action_id is null.
 */
import fetch from "@lib/fetch";

import type { DecisioningStudioActionBankWriteError } from "../decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions/types";
import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdCacheKeys } from "./constants";
import type {
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdProps,
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult,
} from "./types";

export const patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId =
  reactQueryMutationAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdCacheKeys,
    createMutationFetcherFunctionWithShadowError<DecisioningStudioActionBankWriteError>()(
      (
        props: PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdProps
      ): Promise<PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult> => {
        return fetch(
          `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/dimensions/${props.dimension}/actions/${props.actionId}`,
          "PATCH",
          {
            fields: props.fields,
          },
          undefined,
          { propagateFetchRequestError: false }
        );
      }
    )
  );
